"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistanceInput = void 0;
var core_shared_1 = require("@ikegps/core-shared");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var theme_1 = require("../theme");
var distance_input_style_1 = require("./distance.input.style");
var input_1 = require("./input");
var unit_1 = require("./unit");
(0, theme_1.addStyles)(distance_input_style_1.Style);
exports.DistanceInput = {
    view: function (state, unit) {
        if (unit === void 0) { unit = services_1.Services.UserSettings.units; }
        var children;
        if (unit === core_shared_1.IkeUnit.METER) {
            children = exports.DistanceInput.viewMetric(state.meters);
        }
        else {
            children = exports.DistanceInput.viewImperial(state.feet, state.inch);
        }
        return (0, mithril_1.m)('div', { className: distance_input_style_1.CSS.container }, children);
    },
    viewMetric: function (state) {
        return [
            input_1.Input.view(state),
            unit_1.Unit.view(i18n_1.T.UNIT_SHORT_METER)
        ];
    },
    viewImperial: function (feetState, inchState) {
        return [
            input_1.Input.view(feetState),
            unit_1.Unit.view(i18n_1.T.UNIT_SHORT_FEET),
            input_1.Input.view(inchState),
            unit_1.Unit.view(i18n_1.T.UNIT_SHORT_INCH)
        ];
    }
};
//# sourceMappingURL=distance.input.js.map